export default {
  /**
    * @description title shown in browser
    */
  appTitle: '量子智慧车库',

  /**
    * @description default page size
    */
  defaultPageSize: 20,

  /**
    * @description page sizer
    */
  pageSizeList: [20, 30, 40, 50, 60, 100],

  /**
   * @description baidu map api key
   */
  baiduMapKey: 'juPu3gpfaciY45CvFWBY79WLgwFYSaxP',

  /**
   * @description mocked api context path
   */
  apiMockContext: 'https://my-json-server.typicode.com/jeccyzhao',

  /**
   * @description local api context path
   */
  apiContextPath: '/api/v1',

  /**
   * 启用远程API请求调用
   */
  remoteBaseUriEnabled: false,

  /**
   * 远程API请求地址
   */
  remoteBaseUri: 'https://www.yikeliangzi.com/gateway',
  // remoteBaseUri: 'http://47.108.217.191',

  /**
   * @description web socket host
   */
  socketHost: process.env.NODE_ENV === 'production' ? 'ips-openapi-service' : 'localhost:9092',

  /**
   * 车库号段区间容量
   */
  segmentCapacity: [1000, 20000], // [1000, 5000, 10000, 20000],

  /**
   * 车辆编码前缀
   */
  planetNumberPrefix: 'F',

  /**
   * 车库类型
   */
  parkingTypes: [
    { value: 0, title: '豪华版', label: '豪华版', description: '人脸加射频' },
    { value: 1, title: '标准版', label: '标准版', description: '人脸无射频' },
    { value: 2, title: '普通版', label: '普通版', description: '刷卡加扫码' },
    { value: 3, title: '极简版', label: '极简版', description: '手机扫码' },
    { value: 4, title: '其他', label: '其他', description: '射频感应' }
  ],

  /**
   * 车库新老标志
   */
  parkingFreshTypes: [
    { value: 0, title: '老车库', label: '老车库' },
    { value: 1, title: '新车库', label: '新车库' }
  ],

  /**
   * 车库开放注册
   */
  parkingOpenTypes: [
    { value: 0, title: '禁止', label: '禁止' },
    { value: 1, title: '开放', label: '开放' }
  ],

  /**
   * 埋点事件类型
   */
  trackingEventTypes: [
    { value: 0, title: '统计', label: '数量统计' },
    { value: 1, title: '事件', label: '事件埋点' }
  ],

  /**
   * 埋点数据类型
   */
  trackingDataTypes: [
    { value: 0, title: '广告', label: '广告类型' },
    { value: 1, title: '新闻', label: '新闻类型' }
  ],

  /**
   * 设备类型
   */
  deviceTypes: [
    { label: '人脸机', value: 1 },
    { label: 'RFID射频', value: 2 },
    { label: '刷卡机', value: 3 },
    { label: '未知设备类型', value: 4 }
  ],

  /**
   * 设备进出
   */
  deviceEntryTypes: [
    { label: '进', value: 1 },
    { label: '出', value: 2 }
  ],

  /**
   * 告警级别
   */
  alarmSeverities: [
    { label: '一般', value: 1 },
    { label: '中等', value: 2 },
    { label: '严重', value: 3 },
    { label: '未知', value: 0 }
  ],

  /**
   * 开门方式
   */
  doorOpenTypes: [
    { label: '刷脸', value: 0 },
    { label: '刷卡', value: 1 },
    { label: '临停手机', value: 2 },
    { label: '包月手机', value: 3 },
    { label: '管理员远程', value: 4 },
    { label: '其他', value: 5 }
  ],

  /**
   * 告警状态
   */
  alarmStatus: [
    { label: '待处理', value: 0 },
    { label: '已确认', value: 1 }
  ],

  /**
   * 终端软件下发状态
   */
  agentProvisionStatus: [
    { label: '正在下发', value: 1 },
    { label: '下发失败', value: 3 },
    { label: '下发成功', value: 2 }
  ],

  /**
   * 车库运行类型
   */
  parkingBusinessType: [
    { label: '直营', value: 0 },
    { label: '授权(采购设备)', value: 1 },
    { label: '分成', value: 2 },
    { label: '租赁', value: 3 },
    { label: '充电娃', value: 4 },
    { label: '其他', value: 5 }
  ],

  /**
   * 广告显示策略
   */
  advShowPolicy: [
    { label: '每天一次', value: 0 },
    { label: '每周一次', value: 1 },
    { label: '每月一次', value: 2 },
    { label: '每年一次', value: 3 }
  ],

  /**
   * 车辆编码位数
   */
  planetNumberLength: 9,

  // /**
  //  * @description authentication host
  //  */
  // authHost: '/', //process.env.NODE_ENV === 'production' ? 'ips-auth-service' : 'localhost:9095',

  /**
   * @description photo server
   */
  storageHost: 'https://www.yikeliangzi.com',

  /**
   * @description image file extension
   */
  imageFileExt: '.png',

  /**
    * @description i18n enabled
    */
  useI18n: true,

  /**
    * @description default table offset height
    */
  tableOffsetHeight: 170,

  /**
 * @description 默认打开的首页的路由name值，默认为home
 */
  homeName: 'Home',

  /**
    * @description api base url
    */
  baseUrl: {
    dev: 'http://127.0.0.1:9092/api/v1',
    pro: 'http://127.0.0.1:9092/api/v1'
  },

  /**
    * @description enable cache image loading
    */
  imageCache: {
    enabled: true,
    url: 'https://images.weserv.nl/?url='
  },

  /**
    * @description storage key
    */
  storageKeys: {
  }
}

